const ORDER_STATUS = {
  TO_REVIEW: "TO_REVIEW",
  VALIDATED: "VALIDATED",
  PENDING: "PENDING",
  WAITING_FOR_CUSTOMER: "WAITING_FOR_CUSTOMER",
  CANCELLED: "CANCELLED",
};

const DELIVERY_STATUS = {
  ASSIGNED: "ASSIGNED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
};

export { ORDER_STATUS, DELIVERY_STATUS };
